import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import imageIcon from "@ckeditor/ckeditor5-core/theme/icons/image.svg"
import FileDialogButtonView from "@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview"
import api from "../../honcierge-api"

export default class InsertImage extends Plugin {
  init() {
    const editor = this.editor
    editor.ui.componentFactory.add("insertImage", (locale) => {
      const view = new FileDialogButtonView(locale)
      view.set({
        acceptedType: "image/*",
        allowMultipleFiles: false,
      })

      view.buttonView.set({
        label: "画像",
        icon: imageIcon,
        tooltip: true,
      })

      view.on("done", (_event, files) => {
        if (files.length != 1) {
          return
        } else {
          api
            .createDirectUpload(files[0])
            .then((res) => {
              api
                .getImageUrl(res.id)
                .then((res) => {
                  editor.execute("imageInsert", {
                    source: [res.data.url],
                  })
                })
                .catch(() => {
                  console.log("image insert error")
                })
            })
            .catch(() => {
              console.log("direct upload error")
            })
        }
      })
      return view
    })
  }
}
